/**
 * @author Ariel
 * @description 经销商新增编辑页面
 * @Date 2020/1/10
 * @Update 地址不使用及联组件
 */
import React from "react";
import {connect} from 'dva';
import {framework_tool, component_tool, utils_tool} from '@/tool'
import moment from 'moment'
import {WizTableForm} from "../../../common";

let {WizContainer, modelUtils} = framework_tool;
let {WizCard, WizForm, WizSpin} = component_tool;
let {Session} = utils_tool
const organizationAreaConfig = WizTableForm.Config.dealer(this, {apiParams: {state: 1, organizationNodeCategory:3}})

class DealerDetail extends WizContainer {
  componentName = 'dealerDetail';

  constructor(props) {
    super(props);
    const {history} = props;
    let initialValue = {};
    let dealerState = 2;
    let cardTitle = '新增'
    if (history.location && history.location.pathname === '/org/dealer/dealerDetailUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        dealerState = initialValue.state;
        Session.set('dealerDetailUpd', initialValue)
        Session.set('dealerState', dealerState)
      } else {
        initialValue = Session.get('dealerDetailUpd') || {};
        dealerState = Session.get('dealerState') || 2;
      }
      cardTitle = '编辑'
    }
    this.state = {
      cardTitle,
      name: null
    }
    this.dealerState = dealerState;
    this.initialValue = initialValue;
  }

  _componentDidMonut() {
    const {history} = this.props;
  }

  propsAndStateOnChange = {
    addDealer: this._addDealerOver.bind(this)
  }

  /**
   * 经销商变动成功返回原页面，失败弹出提示
   * @param nextProps
   * @param nextState
   * @private
   */
  _addDealerOver(nextProps, nextState) {
    if (nextProps.addDealer.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/org/dealer');
    } else {
      wizNotice.error('提交失败：' + nextProps.addDealer.msg);
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (value != null && value != undefined) {
        if (key === 'openTime') {
          fitterValues[key] = moment(value).format("YYYY-MM-DD HH:mm:ss")
        } else {
          fitterValues[key] = value;
        }
      }
    });
    return fitterValues;
  }

  /**
   * 保存/更新 经销商信息
   * @param values
   * @private
   */
  _saveDealer(values) {
    const {history} = this.props;
    let apiPath = 'dealer/add';
    if (history.location && history.location.pathname === '/org/dealer/dealerDetailUpd') {
      apiPath = "dealer/update"
    }
    let fitterValues = this.fitterFieldsValue(values)
    this.doAction({
      path: apiPath,
      payload: {
        key: "addDealer",
        apiParams: {
          ...fitterValues
        }
      }
    });
  }

  _render() {
    const {dealerLoading} = this.props;
    let initialValue = this.initialValue;
    const {areaId, dealerParentInfo} = initialValue
    let initOrgId = null
    let initDealerParentInfo = [];
    if (areaId) {
      initOrgId = areaId
    }
    if (dealerParentInfo && dealerParentInfo[0]) {
      initDealerParentInfo = dealerParentInfo
    }
    let columns = [
      {
        name: 'id',
        formItem: {
          type: 'hidden',
          initialValue: this.initialValue.id
        }
      },
      {
        name: 'nevType',
        formItem: {
          type: 'hidden',
          initialValue: this.initialValue.nevType
        }
      },
      {
        title: '经销商名称',
        name: 'name',
        formItem: {
          maxLength: 30,
          placeholder: '经销商名称最多输入30个字',
          rules: [
            {
              required: true,
              message: '请输入经销商名称',
            },
            {
              pattern: /^[^\s]*$/,
              message: '经销商名称录入信息不能包含空格'
            }
          ],
          initialValue: this.initialValue.name
        }
      },
      {
        title: '经销商简称',
        name: 'shortName',
        formItem: {
          maxLength: 30,
          placeholder: '经销商简称最多输入30个字',
          rules: [
            {
              required: true,
              message: '请输入经销商简称',
            },
            {
              pattern: /^[^\s]*$/,
              message: '经销商简称录入信息不能包含空格'
            }
          ],
          initialValue: this.initialValue.shortName
        }
      },
      {
        title: '销售代码',
        name: 'preSalesNumber',
        formItem: {
          maxLength: 20,
          placeholder: '销售代码最多输入20个字',
          rules: [
            {
              pattern: /^[^\u4e00-\u9fa5, ]{0,}$/,
              message: '销售代码禁止输入中文和空格'
            }
          ],
          initialValue: this.initialValue.preSalesNumber
        }
      },
      {
        title: '售后代码',
        name: 'afterSalesNumber',
        formItem: {
          maxLength: 20,
          placeholder: '售后代码最多输入20个字',
          rules: [
            {
              pattern: /^[^\u4e00-\u9fa5, ]{0,}$/,
              message: '售后代码禁止输入中文和空格'
            }
          ],
          initialValue: this.initialValue.afterSalesNumber
        }
      },
      {
        title: '上级组织',
        name: 'orgId',
        formItem: {
          ...organizationAreaConfig,
          diy: WizTableForm,
          initialValue: initOrgId,
          initRows: initDealerParentInfo,
          selectType: 'radio',
          rules: [{
            required: true,
            message: '请选择上级组织',
          }]
        }
      },
      {
        title: '站点类型',
        name: 'type',
        dict: [
          {code: 1, codeName: '4S网点'},
          {code: 2, codeName: '直营店'},
          {code: 3, codeName: '单一售后'},
          {code: 4, codeName: '单一销售'},
          {code: 5, codeName: '卫星店/直营店'},
          {code: 6, codeName: '自修站'},
          {code: 7, codeName: '卫星店'},
          {code: 8, codeName: '精品店'},
          {code: 9, codeName: 'dealer'},
          {code: 10, codeName: '4S店'},
          {code: 11, codeName: '汽车零售'},
          { code: 12, codeName: '单一销售展厅' },
          { code: 13, codeName: 'NEV单一售后' },
          { code: 14, codeName: '轻量化4S网点' },
          { code: 15, codeName: 'NEV专区' },
          { code: 16, codeName: '商超店' },
          { code: 17, codeName: '自修店' },
          { code: 18, codeName: '二级网点' },
          { code: 19, codeName: '车工坊C1' },
          { code: 20, codeName: '车工坊C2' },
          { code: 21, codeName: '车工坊B' },
          { code: 22, codeName: '德科品牌授权经销商' },
          { code: 99, codeName: '暂定' },
          {code: 0, codeName: '无'}
        ],
        formItem: {
          rules: [{
            required: true,
            message: '请选择站点类型',
          }],
          initialValue: this.initialValue.type,
          type: 'select'
        }
      },
      {
        title: '开店状态',
        name: 'state',
        dataIndex: 'state',
        dict: [
          {code: 2, codeName: '建设中'},
          {code: 1, codeName: '已开店'},
          {code: 0, codeName: '已关店'}
        ],
        formItem: {
          rules: [{
            required: true,
            message: '请选择开店状态',
          }],
          initialValue: this.dealerState,
          type: 'select'
        }
      },
      {
        title: '开店时间',
        name: 'openTime',
        formItem: {
          type: 'datetime',
          initialValue: this.initialValue.openTime ? this.initialValue.openTime : null
        }
      },
      {
        title: '省份',
        name: 'province',
        formItem: {
          maxLength: 30,
          placeholder: '省份最多输入30个字',
          rules: [
            {
              required: true,
              message: '请输入省份',
            },
            {
              pattern: /^[\u4e00-\u9fa5]+$/,
              message: '省份只允许输入中文'
            }
          ],
          initialValue: this.initialValue.province
        }
      },
      {
        title: '城市',
        name: 'city',
        formItem: {
          maxLength: 30,
          placeholder: '城市最多输入30个字',
          rules: [
            {
              required: true,
              message: '请输入城市',
            },
            {
              pattern: /^[\u4e00-\u9fa5]+$/,
              message: '城市只允许输入中文'
            }
          ],
          initialValue: this.initialValue.city
        }
      },
      {
        title: '地区',
        name: 'region',
        formItem: {
          maxLength: 30,
          placeholder: '地区最多输入30个字',
          initialValue: this.initialValue.region
        }
      },
      {
        title: '详细地址',
        name: 'address',
        formItem: {
          maxLength: 100,
          placeholder: '详细地址最多输入100个字',
          rules: [{
            required: true,
            message: '请输入详细地址',
          }],
          initialValue: this.initialValue.address
        }
      },
      {
        title: '所属集团',
        name: 'bloc',
        formItem: {
          maxLength: 20,
          placeholder: '所属集团最多输入20个字',
          initialValue: this.initialValue.bloc
        }
      },
      {
        title: '备注',
        name: 'remark',
        formItem: {
          maxLength: 100,
          placeholder: '备注最多输入100个字',
          type: 'textarea',
          initialValue: this.initialValue.remark
        }
      }
    ]

    let onSubmit = this._saveDealer.bind(this);

    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 17}
      }
    }

    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={dealerLoading}>
          <WizForm className={'form-inline'} {...formProps} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {dealer} = state;
  const addDealer = modelUtils.getModelEntity(dealer, "addDealer");
  const load = modelUtils.getLoadingState(state, ['dealer']);
  return {
    addDealer: addDealer,
    ...load
  }
};

export default connect(mapStateToProps)(DealerDetail);
